import React from 'react';
import "./Contact.css";
import gitHubIcon from "../assets/github-mark.png";
import linkedInIcon from "../assets/InBug-Black.png";
import discordIcon from "../assets/Discord-Symbol-Black.png";

export default function Contact() {
    return (
        <div className="contactSection">
            <h1>Ota Yhteyttä</h1>

            <div className="contactInfo">
                <p>Voit halutessasi ottaa yhteyttä vaikkapa sähköpostilla tai Discordin kautta</p>
                <div className="contactItem">
                    <p>Sähköposti:</p>
                    <a href="mailto:ronkainenja@gmail.com">ronkainen@hotmail.fi</a>
                </div>
            </div>

            <div className="contactServices">
                <p>Muissa palveluissa:</p>
                <div className="socialLinks">
                    <a href="https://github.com/t3roja" target="_blank" rel="noopener noreferrer">
                        <img className="contactIcon" src={gitHubIcon} alt="GitHub Profile" />
                    </a>
                    <a href="https://www.linkedin.com/in/jani-ronkainen-216190210/" target="_blank" rel="noopener noreferrer">
                        <img className="contactIcon" src={linkedInIcon} alt="LinkedIn Profile" />
                    </a>
                    <a href="https://discordapp.com/users/1144168289027756125" target="_blank" rel="noopener noreferrer">
                        <img className="contactIcon" src={discordIcon} alt="Discord Profile" />
                    </a>
                </div>
            </div>
        </div>
    );
}
